import(/* webpackMode: "eager" */ "/src/web-app/src/app/error.tsx");
